{{ collapsedText }}@if (canExpand()) {<span class="small text-muted" (click)="expand()" role="button">...</span>
}@if (canCollapse()) {<span class="small text-muted" (click)="collapse()" role="button">
  <i class="bi bi-eye-slash-fill ms-1 text-muted"></i></span>
}
